import { NotificationConfiguration } from '../notification.templates';

export const RACI_DECISION_IMPLEMENTED_TEMPLATE: NotificationConfiguration = {
  inapp: `The decision is implemented.`,
  email: {
    ctaKey: 'go_to_decision',
  },
};
